export const en = {
  Page_index_header_logo: '/static/en/logo.png',
  Page_index_header_form_username_placeholder: 'User Name',
  Page_index_header_form_password_placeholder: 'Password',
  Page_index_header_form_submit_buttonText: 'Sign in',
  Page_index_register_text: 'Register',
  Page_index_forget_text: 'Retrieve password',
  Page_index_banner_imgs_1: '/static/en/banners/1.jpg',
  Page_index_banner_imgs_2: '/static/en/banners/2.jpg',
  Page_index_banner_imgs_3: '/static/en/banners/3.jpg',
  Page_index_banner_description_content_1: 'aybases is a tech-enabled logistics group that specialized in providing end-to-end cross-border logistics and local fulfillment solutions.',
  Page_index_banner_description_content_2: 'We pick, pack and ship your e-commerce orders accurately and timely, so you can grow your business without any concern on the logistics part.',
  // Page_index_slogan_1_title: '模式',
  // Page_index_slogan_1_description_1: '聚焦垂直仓',
  // Page_index_slogan_1_description_2: '兼容综合仓',
  // Page_index_slogan_2_title: '模式2',
  // Page_index_slogan_2_description_1: '聚焦垂直仓2',
  // Page_index_slogan_2_description_2: '兼容综合仓2',
  // Page_index_slogan_3_title: '模式3',
  // Page_index_slogan_3_description_1: '聚焦垂直仓3',
  // Page_index_slogan_3_description_2: '兼容综合仓3',
  // Page_index_slogan_4_title: '模式4',
  // Page_index_slogan_4_description_1: '聚焦垂直仓4',
  // Page_index_slogan_4_description_2: '兼容综合仓4',
  // Page_index_slogan_5_title: '模式5',
  // Page_index_slogan_5_description_1: '聚焦垂直仓5',
  // Page_index_slogan_5_description_2: '兼容综合仓5',
  Page_index_products_1_title: 'B2C Fulfillment',
  Page_index_products_1_description_1: 'Retail Inventory Storage & Express Delivery ',
  Page_index_products_2_title: 'B2B Fulfillment',
  Page_index_products_2_description_1: 'Wholesale Inventory Storage & Freight Delivery ',
  Page_index_products_3_title: 'Return Service',
  Page_index_products_3_description_1: 'Return Package Inspection & Refurbish ',
  Page_index_products_4_title: 'Reverse logistic',
  Page_index_products_4_description_1: 'Return Inventory Re-packaging & Back to Stock',
  Page_index_products_5_title: 'Cross-dock',
  Page_index_products_6_title: 'First Leg',
  Page_index_footer_banner: '/static/en/footer.jpg',
  Page_index_footer_content_business_left: 'business:business@aybases.com',
  Page_index_footer_content_business_right: 'aybases US',
  Page_index_footer_content_service_left: 'service:service@aybases.com',
  Page_index_footer_content_service_right: 'aybases HongKong Group',
  Page_index_footer_content_record_left: '沪ICP备19027168号',
  Page_index_footer_content_record_right: 'aybases Shanghai Technology',
  Page_index_footer_content_copyRight_left: 'Copyright©2019 aybases（ALL YOUR BASES）All Rights Reserved.',
  Page_index_footer_content_copyRight_right: 'aybases Shanghai Freight Forwarding',
}

export const  cn = {
  Page_index_header_logo: '/static/cn/logo.png',
  Page_index_header_form_username_placeholder: '请输入用户名',
  Page_index_header_form_password_placeholder: '请输入密码',
  Page_index_header_form_submit_buttonText: '登录',
  Page_index_register_text: '注册',
  Page_index_forget_text: '找回密码',
  Page_index_banner_imgs_1: '/static/en/banners/1.jpg',
  Page_index_banner_imgs_2: '/static/en/banners/2.jpg',
  Page_index_banner_imgs_3: '/static/en/banners/3.jpg',
  Page_index_slogan_1_title: '模式',
  Page_index_slogan_1_description_1: '聚焦垂直仓',
  Page_index_slogan_1_description_2: '兼容综合仓',
  Page_index_slogan_2_title: '服务',
  Page_index_slogan_2_description_1: '配套众平台',
  Page_index_slogan_2_description_2: '补足各断层',
  Page_index_slogan_3_title: '产品',
  Page_index_slogan_3_description_1: '宏观标准化',
  Page_index_slogan_3_description_2: '微观灵活化',
  Page_index_slogan_4_title: '信念',
  Page_index_slogan_4_description_1: '坚守专业性',
  Page_index_slogan_4_description_2: '真给专属性',
  Page_index_slogan_5_title: '集群',
  Page_index_slogan_5_description_1: '标准化体系',
  Page_index_slogan_5_description_2: '复制加盟仓',
  Page_index_products_1_title: 'B2C仓配',
  Page_index_products_2_title: 'B2B仓配',
  Page_index_products_3_title: '退货处理',
  Page_index_products_4_title: '逆向物流',
  Page_index_products_5_title: '落地配',
  Page_index_products_6_title: '配套头程',
  Page_index_show_news: 'true',
  Page_index_footer_content_business_left: '合作请联系：business@aybases.com',
  Page_index_footer_content_service_left: '客服请联系：service@aybases.com',
  Page_index_footer_content_record_left: '沪ICP备19027168号  版权所有©2021 aybases（己仓）保留所有权利.',
}